import { axios } from 'api'

export const fetchProducts = async (
  itemClass: string,
  color?: string,
  itemCategory?: string,
  cabinetType?: string
) => {
  let url = `products?itemClass=${encodeURIComponent(itemClass)}`

  if (color) {
    url += `&color=${encodeURIComponent(color)}`
  }
  if (itemCategory) {
    url += `&itemCategory=${encodeURIComponent(itemCategory)}`
  }
  if (cabinetType) {
    url += `&cabinetType=${encodeURIComponent(cabinetType)}`
  }

  const response = await axios.get(url)

  if (response && response.data) {
    return response.data.products
  }
}

export const syncProductsStockBySkus = async (
  skus: string[]
): Promise<{ sku: string; stock: number }[]> => {
  const response = await axios.post(`/products/sync-products-stock`, { skus })
  return response.data.products
}
